import { useState, useEffect, useImperativeHandle, forwardRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { toast } from "react-toastify";
import SearchInput from "../../../utils/SearchInput";
import TableLoader from "../../../utils/TableLoader";
import PaginationComponent from "../../../utils/PaginationComponent";
import { FaLink, FaPlus } from "react-icons/fa";
import { MdSaveAlt } from "react-icons/md";
import { BsThreeDotsVertical } from "react-icons/bs";
import { TbEdit } from "react-icons/tb";
import { BiSolidTrashAlt } from "react-icons/bi";
import MenuAdd from "./MenuAdd/MenuAdd";
import MenuEdit from "./MenuEdit/MenuEdit";
import MenuView from "./MenuView";

const MenuManagement = (props, ref) => {
  const navigate = useNavigate();
  const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
  const token = localStorage.getItem("token");
  const [menulistData, setMenuListData] = useState([]);
  const [isLoading, setIsLoading] = useState({
    main: false,
    edit: false,
    save: false,
  });
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [selectedDishes, setSelectedDishes] = useState([]);

  const [editMenuDish, setEditMenuDish] = useState([]);
  const [isChecked, setIsChecked] = useState(0);
  const [isBeverage, setIsBeverage] = useState(0);
  const [menuData, setMenuData] = useState({
    name: "",
    // status: false,
    description: "",
    show_description: 0,
  });

  const [currentMenusData, setCurrentMenusData] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [isAdd, setIsAdd] = useState(false);
  const [isViewing, setIsViewing] = useState(false);
  const [dialog, setDialog] = useState(false);
  const [selectedMenuId, setSelectedMenuId] = useState(null);
  const { rest_slug2 } = useParams();
  // const [searchText, setSearchText] = useState(() => {
  //   return localStorage.getItem("searchText") || "";
  // });

  const [searchText, setSearchText] = useState("");

  const [toggleStatus, setToggleStatus] = useState();
  const [statusValue, setStatusValue] = useState("");
  const states = ["active", "inactive"];

  const days = [
    "Lunedì",
    "Martedì",
    "Mercoledì",
    "Giovedì",
    "Venerdì",
    "Sabato",
    "Domenica",
  ];

  const [timeSlots, setTimeSlots] = useState({});

  const firstAvailableDay = Object.keys(timeSlots)?.[0] || "";

  const [activeDay, setActiveDay] = useState(firstAvailableDay);
  // const [activeDay, setActiveDay] = useState("");

  useEffect(() => {
    if (Object.keys(timeSlots).length > 0) {
      setActiveDay(firstAvailableDay);
    }
  }, [firstAvailableDay]);

  useEffect(() => {
    if (
      currentMenusData?.name ||
      currentMenusData?.status ||
      currentMenusData?.description ||
      currentMenusData?.dishes
    ) {
      const modifyDishObject =
        currentMenusData?.dishes?.map((dish) => ({
          id: dish?.id,
          full_price: dish?.pivot?.full_price || "0.00",
          half_price: dish?.pivot?.half_price || "0.00",
          is_option_to_be_half_dish:
            dish?.pivot?.is_option_to_be_half_dish === 1 ? true : false,
          is_option_to_be_full_dish:
            dish?.pivot?.is_option_to_be_full_dish === 1 ? true : false,
        })) || [];

      setMenuData({
        name: currentMenusData?.name || "",
        description: currentMenusData?.description || "",
        status: currentMenusData?.status || false,
        // dishes: currentMenusData?.dishes || []
        dishes: modifyDishObject || [],
        show_description: currentMenusData?.show_description || 0,
      });

      const dishedIds =
        currentMenusData?.dishes?.map((dish) => ({
          id: dish.id,
          full_price: dish.pivot.full_price || "0.00",
          half_price: dish.pivot.half_price || "0.00",
          is_option_to_be_half_dish: dish.pivot.is_option_to_be_half_dish,
          is_option_to_be_full_dish: dish.pivot.is_option_to_be_full_dish,
        })) || [];

      setSelectedDishes(dishedIds);

      setEditMenuDish(dishedIds);

      setStatusValue(currentMenusData?.status);

      const timeSlotsArray = currentMenusData?.time_slots || [];
      const transformedTimeSlots = timeSlotsArray.reduce((acc, slot) => {
        const italianDay = englishToItalian[slot.day.toLowerCase()];
        if (!acc[italianDay]) acc[italianDay] = [];
        acc[italianDay].push({
          start_time: slot.start_time.slice(0, 5),
          end_time: slot.end_time.slice(0, 5),
        });
        return acc;
      }, {});

      setTimeSlots(transformedTimeSlots);
    }
  }, [currentMenusData]);

  const englishToItalian = {
    monday: "Lunedì",
    tuesday: "Martedì",
    wednesday: "Mercoledì",
    thursday: "Giovedì",
    friday: "Venerdì",
    saturday: "Sabato",
    sunday: "Domenica",
  };

  const handleAddTimeSlot = (day) => {
    let isValid = true;
    const currentSlots = timeSlots[day] || [];

    if (currentSlots.some((slot) => !slot.start_time || !slot.end_time)) {
      toast.error(
        "Please complete all existing time slots before adding a new one.",
        { theme: "colored", autoClose: 1000 }
      );
      return;
    }

    for (let i = 0; i < currentSlots.length; i++) {
      const slot = currentSlots[i];
      if (
        slot.start_time &&
        slot.end_time &&
        slot.start_time >= slot.end_time
      ) {
        toast.error("The end time must be greater than the start time.", {
          theme: "colored",
          autoClose: 1000,
        });
        isValid = false;
        break;
      }
    }

    if (isValid) {
      setTimeSlots((prev) => ({
        ...prev,
        [day]: [
          ...(prev[day] || []),
          { start_time: "00:00", end_time: "23:59" },
        ],
      }));
    }
  };

  const handleTimeSlotChange = (day, index, field, value) => {
    console.log(timeSlots, "timeSlot");
    setTimeSlots((prev) => {
      const updatedSlots = [...(prev[day] || [])];
      updatedSlots[index][field] = value;
      return { ...prev, [day]: updatedSlots };
    });
  };

  const validSlot = () => {
    let isValid = true;

    if (statusValue === "inactive") {
      return true;
    }

    if (Object.keys(timeSlots).length === 0) {
      toast.error("At least one time slot must be added.", {
        theme: "colored",
        autoClose: 1000,
      });
      return false;
    }

    for (let day in timeSlots) {
      const currentSlots = timeSlots[day];

      if (currentSlots.length === 0) {
        toast.error(`At least one time slot is required for ${day}.`, {
          theme: "colored",
          autoClose: 1000,
        });
        isValid = false;
        break;
      }

      for (let i = 0; i < currentSlots.length; i++) {
        const slot = currentSlots[i];

        if (!slot.start_time || !slot.end_time) {
          toast.error(`Both start and end times are required for ${day}.`, {
            theme: "colored",
            autoClose: 1000,
          });
          isValid = false;
          break;
        }

        if (slot.start_time >= slot.end_time) {
          toast.error(
            `The end time must be greater than or not equal to the start time  ${day}.`,
            { theme: "colored", autoClose: 1000 }
          );
          isValid = false;
          break;
        }
      }

      if (!isValid) break;
    }

    return isValid;
  };

  const handleRemoveTimeSlot = (key, index) => {
    setTimeSlots((prev) => {
      if (prev && prev[key] && Array.isArray(prev[key])) {
        const updatedTimeSlots = { ...prev };
        updatedTimeSlots[key] = updatedTimeSlots[key].filter(
          (_, i) => i !== index
        );
        if (updatedTimeSlots[key].length === 0) {
          delete updatedTimeSlots[key];
        }
        return updatedTimeSlots;
      }
      return prev;
    });
  };

  const handleSearchChange = (value) => {
    setSearchText(value);
  };

  const getMenusListData = async () => {
    setIsLoading({ ...isLoading, main: true });
    try {
      let params;
      if (searchText) {
        params = {
          pageNumber: page,
          size: rowsPerPage,
          search: searchText,
        };
      } else {
        params = {
          pageNumber: page,
          size: rowsPerPage,
        };
      }
      const response = await axios.get(
        `${apiUrl}/api/v1/restaurants/${rest_slug2}/menus`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params,
        }
      );

      const data = response?.data;
      console.log(data);
      setMenuListData(data?.data);
      setTotalPages(data?.total);
    } catch (error) {
      console.error("Error fetching order data:", error);
    } finally {
      setIsLoading({ ...isLoading, main: false });
    }
  };

  const getRestProfileData = async () => {
    try {
      const responseProfileData = await axios.get(
        `${apiUrl}/api/v1/restaurants/${rest_slug2}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setIsChecked(responseProfileData?.data?.is_show_menu || 0);
      setIsBeverage(responseProfileData?.data?.is_show_beverages || 0);
    } catch (error) {
      console.error("Error fetching Profile Settings data:", error);
    }
  };

  useEffect(() => {
    getMenusListData();
    getRestProfileData();
  }, [page, rowsPerPage, searchText]);

  const handleSave = async () => {
    if (statusValue === "inactive") {
      toast.warn("Inactive status is not allowed. Please select 'Active'.", {
        autoClose: 1000,
        theme: "colored",
      });
      return;
    }

    if (!validSlot()) {
      return;
    }

    setIsLoading({ ...isLoading, save: true });

    const timeSlotsMap = {
      monday: "Lunedì",
      tuesday: "Martedì",
      wednesday: "Mercoledì",
      thursday: "Giovedì",
      friday: "Venerdì",
      saturday: "Sabato",
      sunday: "Domenica",
    };

    const filteredTimeSlots = Object.entries(timeSlotsMap).reduce(
      (acc, [key, value]) => {
        if (Array.isArray(timeSlots?.[value]) && timeSlots[value].length > 0) {
          acc[key] = timeSlots[value];
        }
        return acc;
      },
      {}
    );

    // console.log(filteredTimeSlots, "filteredTimeSlots");

    try {
      const menuObject = {
        name: menuData.name,
        description: menuData.description,
        status: statusValue,
        dishes: selectedDishes,
        show_description: menuData.show_description || 0,
        time_slots: filteredTimeSlots,
      };

      const response = await axios.put(
        `${apiUrl}/api/v1/menus/${currentMenusData.id}`,
        menuObject,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      getMenusListData();
      toast.success(response?.data?.message || "Menu added successfully!", {
        theme: "colored",
        autoClose: 1000,
      });
      setIsEditing(false);
      navigate(`/restaurantPanel/menuManagement/${rest_slug2}`);
    } catch (error) {
      const errors = error?.response?.data?.errors;
      if (errors) {
        for (const key in errors) {
          if (Array.isArray(errors[key])) {
            errors[key].forEach((message) => {
              toast.error(message, {
                theme: "colored",
                autoClose: 3000,
              });
            });
          }
        }
      } else {
        toast.error(error?.response?.data?.message, {
          theme: "colored",
          autoClose: 3000,
        });
      }
    } finally {
      setIsLoading({ ...isLoading, save: false });
      setTimeSlots({});
    }
  };

  const handleDelete = async (Id) => {
    if (!Id) {
      console.error("Error: ID is required to delete a menu.");
      return;
    }
    setIsLoading({ ...isLoading, main: true });
    try {
      const response = await axios.delete(`${apiUrl}/api/v1/menus/${Id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      getMenusListData();
      setTimeout(() => {
        toast.success(response?.data?.message, {
          theme: "colored",
          autoClose: 1000,
        });
      }, 1500);
      // toast.success(response?.data?.message, { theme: "colored", autoClose: 1000 })
    } catch (error) {
      console.error(
        "Error deleting dish:",
        error?.response?.data?.message || error.message
      );
      toast.error("Failed to delete the dish. Please try again.", {
        theme: "colored",
        autoClose: 3000,
      });
    } finally {
      setIsLoading({ ...isLoading, main: false });
    }
  };

  const changeMenulistStatusOld = async (menuDetails, currentStatus) => {
    setIsLoading({ ...isLoading, main: true });
    try {
      const newStatus = currentStatus === "active" ? "inactive" : "active";
      // const dishIds = menuDetails?.dishes.map((dish) => dish);

      const dishIds = menuDetails?.dishes.map((dish) => ({
        id: dish.id,
        full_price: dish?.pivot?.full_price || "0.00",
        half_price: dish?.pivot?.half_price || "0.00",
        is_option_to_be_half_dish: dish?.pivot?.is_option_to_be_half_dish
          ? 1
          : 0,
        is_option_to_be_full_dish: dish?.pivot?.is_option_to_be_full_dish
          ? 1
          : 0,
      }));

      const menuObject = {
        name: menuDetails.name,
        description: menuDetails.description,
        dishes: dishIds,
        status: newStatus,
        show_description: menuDetails?.show_description || 0,
        time_slots: menuDetails?.time_slots,
      };

      // const timeSlotsMap = {
      //   "monday": "Lunedì",
      //   "tuesday": "Martedì",
      //   "wednesday": "Mercoledì",
      //   "thursday": "Giovedì",
      //   "friday": "Venerdì",
      //   "saturday": "Sabato",
      //   "sunday": "Domenica"
      // };

      // const filteredTimeSlots = Object.entries(timeSlotsMap).reduce((acc, [key, value]) => {
      //   if (Array.isArray(timeSlots?.[value]) && timeSlots[value].length > 0) {
      //     acc[key] = timeSlots[value];
      //   }
      //   return acc;
      // }, {});

      // console.log(filteredTimeSlots, "filteredTimeSlots");

      // const menuObject = {
      //   name: menuData.name,
      //   description: menuData.description,
      //   status: statusValue,
      //   dishes: selectedDishes,
      //   show_description: menuData.show_description || 0,
      //   time_slots: filteredTimeSlots,
      // };

      const response = await axios.put(
        `${apiUrl}/api/v1/menus/${menuDetails.id}`,
        menuObject,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      getMenusListData();
      toast.success(response?.data?.message, {
        theme: "colored",
        autoClose: 1000,
      });
    } catch (error) {
      console.error("Error updating menu status:", error);
    } finally {
      setIsLoading({ ...isLoading, main: false });
    }
  };

  const changeMenulistStatus = async (menuDetails, currentStatus) => {
    if (!menuDetails) return;

    setIsLoading((prev) => ({ ...prev, main: true }));

    try {
      // 1. Prepare status and dish data
      const newStatus = currentStatus === "active" ? "inactive" : "active";

      const dishIds =
        menuDetails?.dishes?.map((dish) => ({
          id: dish.id,
          full_price: dish?.pivot?.full_price || "0.00",
          half_price: dish?.pivot?.half_price || "0.00",
          is_option_to_be_half_dish: dish?.pivot?.is_option_to_be_half_dish
            ? 1
            : 0,
          is_option_to_be_full_dish: dish?.pivot?.is_option_to_be_full_dish
            ? 1
            : 0,
        })) || [];

      // 2. Transform time slots
      const englishToItalian = {
        monday: "Lunedì",
        tuesday: "Martedì",
        wednesday: "Mercoledì",
        thursday: "Giovedì",
        friday: "Venerdì",
        saturday: "Sabato",
        sunday: "Domenica",
      };

      const transformedTimeSlots = (menuDetails?.time_slots || []).reduce(
        (acc, slot) => {
          const italianDay = englishToItalian[slot.day.toLowerCase()];
          if (italianDay) {
            if (!acc[italianDay]) acc[italianDay] = [];
            acc[italianDay].push({
              start_time: slot.start_time.slice(0, 5),
              end_time: slot.end_time.slice(0, 5),
            });
          }
          return acc;
        },
        {}
      );

      // 3. Filter time slots to only include days with slots
      const filteredTimeSlots = Object.entries(englishToItalian).reduce(
        (acc, [key, value]) => {
          if (
            Array.isArray(transformedTimeSlots[value]) &&
            transformedTimeSlots[value].length > 0
          ) {
            acc[key] = transformedTimeSlots[value];
          }
          return acc;
        },
        {}
      );

      // 4. Prepare the complete menu object
      const menuObject = {
        name: menuDetails.name,
        description: menuDetails.description,
        dishes: dishIds,
        status: newStatus,
        show_description: menuDetails?.show_description || 0,
        time_slots: filteredTimeSlots,
      };

      // 5. Make API call
      const response = await axios.put(
        `${apiUrl}/api/v1/menus/${menuDetails.id}`,
        menuObject,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      // 6. Handle success
      getMenusListData();
      toast.success(
        response?.data?.message || "Menu status updated successfully",
        {
          theme: "colored",
          autoClose: 1000,
        }
      );
    } catch (error) {
      console.error("Error updating menu status:", error);
      toast.error(
        error.response?.data?.message || "Failed to update menu status",
        {
          theme: "colored",
          autoClose: 2000,
        }
      );
    } finally {
      setIsLoading((prev) => ({ ...prev, main: false }));
    }
  };

  // useEffect(() => {
  //   const handlePageRefresh = () => {
  //     localStorage.removeItem("searchText");
  //   };

  //   window.addEventListener("beforeunload", handlePageRefresh);

  //   return () => {
  //     window.removeEventListener("beforeunload", handlePageRefresh);
  //   };
  // }, [])

  // const handleSearchTextChange = (e) => {
  //   const value = e.target.value;
  //   setSearchText(value);
  //   localStorage.setItem("searchText", value);
  // };

  const handleViewClick = async (user) => {
    setIsViewing(true);
    setCurrentMenusData(user);
  };

  const handleEditClick = async (user) => {
    setIsEditing(true);
    setCurrentMenusData(user);
  };

  const handleCancel = () => {
    setIsEditing(false);
    setIsViewing(false);
    setCurrentMenusData(null);
    setTimeSlots({});
  };

  useImperativeHandle(ref, () => ({
    menu() {
      setIsAdd(false);
      setIsEditing(false);
      setIsViewing(false);
      setCurrentMenusData(null);
    },
  }));

  const changeMenuShowStatus = async () => {
    const newStatus = isChecked ? 0 : 1;
    setIsChecked(!isChecked);
    try {
      const formData = new FormData();
      formData.append("restaurant_id", rest_slug2);
      formData.append("is_show_menu", newStatus);
      formData.append("is_show_beverages", isBeverage);
      const response = await axios.post(
        `${apiUrl}/api/v1/section-status`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      getRestProfileData();

      toast.success(response?.data?.message, {
        theme: "colored",
        autoClose: 1000,
      });
    } catch (error) {
      console.error("Error updating menu status:", error);
    }
  };

  const toggleSwitch = (field) => {
    setMenuData((prev) => ({
      ...prev,
      [field]: prev[field] === 1 ? 0 : 1,
    }));
  };

  return (
    <>
      {isAdd ? (
        <MenuAdd
          setIsAdd={setIsAdd}
          getMenusListData={getMenusListData}
        />
      ) : isEditing ? (
        <MenuEdit
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          menuData={menuData}
          setMenuData={setMenuData}
          currentMenusData={currentMenusData}
          handleSave={handleSave}
          handleCancel={handleCancel}
          selectedDishes={selectedDishes}
          setSelectedDishes={setSelectedDishes}
          toggleStatus={toggleStatus}
          setToggleStatus={setToggleStatus}
          statusValue={statusValue}
          setStatusValue={setStatusValue}
          states={states}
          editMenuDish={editMenuDish}
          setEditMenuDish={setEditMenuDish}
          //============time slot=================

          days={days}
          activeDay={activeDay}
          setActiveDay={setActiveDay}
          timeSlots={timeSlots}
          setTimeSlots={setTimeSlots}
          handleTimeSlotChange={handleTimeSlotChange}
          handleAddTimeSlot={handleAddTimeSlot}
          handleRemoveTimeSlot={handleRemoveTimeSlot}
          //============time slot=================

          toggleSwitch={toggleSwitch}
        />
      ) : isViewing ? (
        <MenuView
          menuData={menuData}
          setMenuData={setMenuData}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          currentMenusData={currentMenusData}
          handleCancel={handleCancel}
          selectedDishes={selectedDishes}
          setSelectedDishes={setSelectedDishes}
          editMenuDish={editMenuDish}
        />
      ) : (
        <section className="border-t border-[#D9D9D9] sm:mt-5 pt-5">
          <div className="flex xl:flex-row flex-col justify-between items-center mt-3 mb-3">
            <div className="flex items-center justify-between gap-x-2 xl:w-auto w-full">
              <h3 className="text-3xl font-bold mb-2 poppins-medium self-start">
                Gestisci Menu
              </h3>
              <div className="flex items-center space-x-2 sm:hidden">
                <label className="cursor-pointer">
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={changeMenuShowStatus}
                    className="sr-only peer"
                  />
                  <div
                    className="relative w-9 h-5 bg-gray-200 peer-focus:outline-none rounded-full
                  peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full
                  after:absolute after:top-[2px] after:start-[2px] after:bg-white after:h-4 after:w-4 after:rounded-full 
                  after:transition-all peer-checked:bg-[#8B2433]"
                  ></div>
                </label>
                <span className="text-sm font-medium poppins-regular w-20 text-left">
                  {isChecked ? "Visibile" : "Nascosto"}
                </span>
              </div>
            </div>
            <div className="self-start flex md:flex-row flex-col items-center gap-4  sm:w-auto w-full">
              <SearchInput
                onSearchChange={handleSearchChange}
                component="Menu Management"
                placeholder="Menu"
              />
              <button
                className="md:w-auto text-center w-full self-start flex items-center justify-center px-2 py-1 bg-[#8A2533] text-white rounded-lg border-2 border-[#953543] hover:text-[#8A2533] hover:bg-[#f6efef] transition-colors group"
                onClick={() => setIsAdd(true)}
              >
                <FaPlus />
                {/* Add Menu */}
                <span className="ml-2 poppins-regular">Aggiungi Menu</span>
              </button>
              <div className="sm:flex items-center space-x-2 hidden">
                <label className="cursor-pointer">
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={changeMenuShowStatus}
                    className="sr-only peer"
                  />
                  <div
                    className="relative w-9 h-5 bg-gray-200 peer-focus:outline-none rounded-full
                  peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full
                  after:absolute after:top-[2px] after:start-[2px] after:bg-white after:h-4 after:w-4 after:rounded-full 
                  after:transition-all peer-checked:bg-[#8B2433]"
                  ></div>
                </label>
                <span className="text-sm font-medium poppins-regular w-20 text-left">
                  {isChecked ? "Visibile" : "Nascosto"}
                </span>
              </div>
            </div>
          </div>
          <div
            className="user-mangement-main shadow-scroll-x relative h-auto bg-[#FBFBFB]
           border-[2px] border-[#8B24332B] px-6 pt-3 pb-0 rounded-xl shadow"
          >
            <table className="lg:w-full md:w-[600px] text-left wine_table">
              <thead>
                <tr className="border-b border-[#8B2433]">
                  <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                    Nome Menu
                  </th>
                  <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                    Descrizione
                  </th>
                  <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                    Stato
                  </th>
                  <th className="pb-3 px-7 text-left poppins-medium text-[#6B6B6B] w-[12%]">
                    Opzioni
                  </th>
                </tr>
              </thead>
              {isLoading?.main ? (
                <TableLoader />
              ) : (
                <tbody>
                  {menulistData && menulistData?.length > 0 ? (
                    menulistData?.map((item, index) => (
                      <tr key={index} className="border-b border-[#8B2433]/12">
                        <td className="text-left lg:w-auto w-[150px] poppins-medium text-[#303030] py-4">
                          {item?.name || "N/A"}
                        </td>
                        <td className="py-4 px-2 lg:w-auto w-[150px] text-left poppins-medium text-[#303030]">
                          {item?.description
                            ? item?.description
                              ?.split(" ")
                              .slice(0, 5)
                              .join(" ") +
                            (item?.description?.split(" ").length > 20
                              ? "..."
                              : "")
                            : "N/A"}
                        </td>
                        <td className="text-start py-4 px-3 lg:w-auto w-[100px]">
                          <label className="inline-flex items-center cursor-pointer">
                            <input
                              type="checkbox"
                              value=""
                              checked={item?.status === "active" ? true : false}
                              onChange={() => {
                                changeMenulistStatus(item, item?.status);
                              }}
                              className="sr-only peer accent-[#8B2433]"
                            />
                            <div
                              className="relative w-9 h-5 bg-gray-200 peer-focus:outline-none rounded-full
                               peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full
                                after:absolute after:top-[2px] after:start-[2px] after:bg-white after:h-4 after:w-4 after:rounded-full after:transition-all peer-checked:bg-[#8B2433]"
                            ></div>
                          </label>
                        </td>
                        <td className="text-start py-4 flex gap-4 w-full items-center justify-center">
                          <button
                            onClick={() =>
                              navigate(
                                `/restaurant/${item?.restaurant?.slug}/menu-list/${item?.id}`
                              )
                            }
                          >
                            <FaLink color="#8B2433" size={"18px"} />
                          </button>
                          <Menu>
                            <MenuButton><BsThreeDotsVertical color="#8B2433" size={"18px"} /></MenuButton>
                            <MenuItems anchor="bottom" className="bg-[#fffbfb] w-[210px] border text-black py-0 flex flex-col  shadow-2xl rounded-xl relative focus-visible:outline-none overflow-hidden">
                              {/* Arrow at the top */}
                              <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-8 border-r-8 border-b-8 border-l-transparent border-r-transparent border-b-white"></div>
                              <MenuItem className="flex gap-2 justify-start items-center poppins-regular px-3 py-2 hover:bg-[#8b2532] hover:text-[#fff] transition-all duration-300 ease-in-out">
                                <button
                                  onClick={() => {
                                    window.open(
                                      `/menu_list_pdf/${item?.id}`,
                                      "_blank"
                                    );
                                  }}
                                  className="w-full text-left flex gap-2 items-center overflow-hidden text-ellipsis"
                                >
                                  <MdSaveAlt size={"18px"} className="flex-shrink-0" />
                                  <span className="whitespace-pre-line leading-tight">Scarica Lista Menu</span>
                                </button>
                              </MenuItem>

                              <MenuItem className="flex gap-2 justify-start border-t items-center poppins-regular px-3 py-2 hover:bg-[#8b2532] hover:text-[#fff] transition-all duration-300 ease-in-out">
                                <button
                                  onClick={() => handleEditClick(item)}
                                  className="w-full text-left flex gap-2 items-center whitespace-nowrap overflow-hidden text-ellipsis"
                                >
                                  <TbEdit size={"18px"} className="flex-shrink-0" />
                                  <span>Modifica</span>
                                </button>
                              </MenuItem>

                              <MenuItem className="flex gap-2 justify-start border-t items-center poppins-regular px-3 py-2 hover:bg-[#8b2532] hover:text-[#fff] transition-all duration-300 ease-in-out">
                                <button className="w-full text-left flex gap-2 items-center whitespace-nowrap overflow-hidden text-ellipsis"
                                  onClick={() => {
                                    setDialog(true);
                                    setSelectedMenuId(item?.id);
                                  }}
                                >
                                  <BiSolidTrashAlt size={"18px"} className="flex-shrink-0" />
                                  <span>Elimina</span>
                                </button>
                              </MenuItem>
                            </MenuItems>
                          </Menu>
                        </td>
                        {dialog && (
                          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                            <div className="bg-white rounded-lg shadow-lg sm:w-1/3 w-[280px]">
                              <div className="px-6 py-4 border-b">
                                <h3 className="text-lg font-semibold text-gray-800 poppins-medium">
                                  Are you sure you want to delete the menu?
                                </h3>
                              </div>
                              <div className="px-6 py-4 flex justify-end space-x-4">
                                <button
                                  onClick={() => {
                                    handleDelete(selectedMenuId);
                                    setDialog(false);
                                  }}
                                  className="px-4 py-2 poppins-regular bg-[#8A2533] text-white rounded-md hover:bg-[#f6efef] hover:text-[#8A2533] transition-colors"
                                >
                                  Yes
                                </button>
                                <button
                                  onClick={() => setDialog(false)}
                                  className="px-4 py-2 poppins-regular bg-gray-300 text-gray-700 rounded-md hover:text-white hover:bg-[#8A2533] transition-colors"
                                >
                                  No
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={9} className="text-center py-4">
                        No menu found
                      </td>
                    </tr>
                  )}
                </tbody>
              )}
            </table>
          </div>
          {menulistData && menulistData?.length > 0 && (
            <PaginationComponent
              page={page}
              totalPages={totalPages}
              rowsPerPage={rowsPerPage}
              setPage={setPage}
              setRowsPerPage={setRowsPerPage}
            />
          )}
        </section>
      )}
    </>
  );
};

export default forwardRef(MenuManagement);
